<mat-icon *ngIf="filter.async; else count">cloud_queue</mat-icon>
<ng-template #count>
  <span>{{ filter.size }}</span>
</ng-template>
